const expiredListeners = new Set();

export function onSessionExpired(listener) {
  expiredListeners.add(listener);
  return () => expiredListeners.delete(listener);
}

export function notifySessionExpired() {
  expiredListeners.forEach((listener) => listener());
}
